<template>
    <div :class="PanelClass" v-show="isActive">
  
      <div class="payitemavailable " > <!-- v-show="priorValid" -->
      
        


        <div  class="payitemavailable">
         
         
          
          <addpayment_culinary buttonClass='btn paymentbutton' name="Card" :defaultAmount="due" @save="addPayItem" :numberDataLabel="cardNumberDataLabel" 
                v-if="showBankcard" :allowOverAvailableAmount="allowPaymentOverDue" :availableAmount="due" :disabled="disablePayments"/>

          
          
        </div>
        
        
        
       
            
        

      </div>

      <!-- regular/not split -->
      <div class="payitemadded " v-if="!ticketIsSplit">
        <label for class="text subtitle">Payments</label>
        <payitem v-for="payItem in payItems" v-bind:key="payItem.id" v-bind:payItem="payItem"  @removeitem="removepayitem" />

        <label for class="text text-right totaltext">Payment Total: {{ payTotal|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Due: {{ due|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Change: {{ change|toCurrency }}</label>
        <div v-show="isValid && zeroDue">

          <button class="btn actionbutton narrowbutton"  @click="receiptOnNewPage" v-if="receiptPrinterType=='newpage'" >Print Receipt</button>
          <button ref="printthereceipt" class="btn actionbutton narrowbutton"  v-print="'#receiptdatadiv'" v-show="false">Print Receipt</button>
        </div>
      
  
      </div>

      <!-- split! -->
      <div class="payitemadded " v-if="ticketIsSplit && selectedSplitGuest!=null">
        <label for class="text subtitle">Payments for {{ selectedSplitGuest }}</label>
        <payitem v-for="payItem in payItems" v-bind:key="payItem.id" v-bind:payItem="payItem"  @removeitem="removepayitem" v-if="payItem.guestNumber==selectedSplitGuest"/>

        <label for class="text text-right totaltext">Payment Total: {{ payTotal_byGuest(selectedSplitGuest)|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Due: {{ due_byGuest(selectedSplitGuest)|toCurrency }}</label>
        <label for class="text text-right totaltext paycolor">Change: {{ change_byGuest(selectedSplitGuest)|toCurrency }}</label>
  
      </div>
  
      <div class="nextbutton">
        <div class="nextbutton">
          <label class="pleasewait" v-if="inPayment">Processing, please wait...</label>
        </div>
  
        <button @click="startKeyedEntry()" class="btn actionbutton" v-if="showKeyedEntryButton && inPayment && usingGeniusTerminal">Keyed Card Entry</button>
        <button @click="startCancelEntry()" class="btn actionbutton" v-if="showKeyedEntryButton && inPayment && usingGeniusTerminal">Cancel Card Entry</button>
        
          <button v-for="payItem in payItems_unprocessedCardOnly" v-bind:key="payItem.id"   class="btn actionbutton" 
              @click="process_terminaltest_single(payItem)" v-if="!inPayment">Process Card for ${{payItem.price.toFixed(2)}}</button>
       
  
        <button class="btn actionbutton" @click="process_terminaltest" v-show="isValid && zeroDue && payItems_unprocessedCardOnly.length==0" :disabled="pleaseWait">{{completeText}}</button>
        <receiptoptions ref="receiptoptions" @close="completeIfAuto" :showButton="!autoReceiptAfterProcess"/>  
        <div hidden>
            <div  class="receiptclass" id="receiptdatadiv" v-if="receiptData!=null" >
              <label>{{receiptData}}</label>
            </div>
          </div>
          
          <div id="drawerdiv">
            <label class="drawerfont"></label>
          </div>
      </div>
   
    </div>
  </template>
  
  <script>
  import {mapFields} from 'vuex-map-fields'
  import payitem from '../actions/payitem.vue'
  import smallbutton from '../controls/button.vue'
  import format from '../../style/format.js'
  import addpayment_culinary from '../actions/addpayment_culinary.vue'
  import addpayment_gift from '../actions/addpayment_gift.vue'
  import print from 'vue-print-nb'
  import pay from '../../services/pay.js'
  import pos from '../../services/pos.js'
  import pos_culinary from '../../services/pos_culinary.js'
  import splitticket from '../actions/splitticket.vue'
  import receiptoptions from '../actions/receiptoptions.vue'
  import linkbutton from '../controls/linkbutton.vue'
  import printreceipthelper from '../../services/printreceipthelper.js'
 
  export default {
    data() {
      return {
        paramTrue:true,
        paramFalse:false,
        
  
      };
    },
    directives:{
      print
    },
    components:{
      payitem,
      addpayment_culinary,
      addpayment_gift,
      smallbutton,
      splitticket,
      receiptoptions,
      linkbutton,
      
  
    },
    mixins:[format,pay,pos,pos_culinary,printreceipthelper],
    props: ["panelIndex"],
    computed: {
      ...mapFields([
              
          ]),
          
      
      isActive: function() {
        return this.panels[this.panelIndex].active;
      },
      isValid: function() {
        return this.panels[this.panelIndex].valid;
      },
      
      priorValid: function() {
        return this.panels[this.panelIndex - 1].valid;
      },
      
      PanelClass: function() {
        var classes = "panel-full panel payfull ";
        if (this.inPayment == true) {
          classes += " panel-unavailable";
        }
        return classes;
      },
      
      
      
    },
    methods: {
      async printForGuest(guestNumber){
 

          this.receiptPrintJob = await this.printReceiptDirectForCurrentTicket(guestNumber)
          this.printReceiptDirect(this.receiptPrintJob)
           
      },
      toNext: function() {
        if(this.AutoStartOver){this.startOver();}
        else{
          var nextPanelIndex = Number(this.panelIndex) + 1;
          this.$store.dispatch('setActivePanel',nextPanelIndex);
          this.panels[2].available = false;
          this.panels[1].available = false;
          this.panels[0].available = false;
        }
        
      },
      startOver: function() {
        this.$store.dispatch('startOver');
  
      },
      
  
    },
    mounted: function() {
      //this.onInit();
    }
  };
  </script>
  <style scoped>
  .drawerfont{
    font:'control';
  }
  .payitemavailable {
    grid-area: payavailable;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    height:100px;
  }
  .payitemadded {
    grid-area: payadded;
    display: flex;
    flex-direction: column;
    border-left: 1px solid gray;
    padding-left:20px;
    margin-left:10px;
    text-align:right;
    align-items: right;
  }
  
  .payfull {
    display: grid;
    grid-template-columns: 1fr 1fr;
    grid-template-rows: auto 80px;
    grid-template-areas:
      "payavailable payadded"
      "next next";
    padding: 20px;
  }
  .allpmt{
    border-bottom:1px solid gray;
    width:100%;
    text-align: left;
  }
  .narrowbutton{
    width:100px;
  }
  .receiptclass{
    margin-top:120px;
    white-space: pre-wrap;
  
  } 
  .splitguestlabel{
    font-size: larger;
  }
.selectedSplitGuestClass{
  border:yellow solid 2px;
  padding:10px;
}
.splitGuestClass{
  padding:10px;
}
  </style>